import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	DatasetComponent,
	TransformComponent,
	DataZoomComponent,
} from 'echarts/components'

use([
	GridComponent,
	DatasetComponent,
	TransformComponent,
	CanvasRenderer,
	LineChart,
	PieChart,
	BarChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	DataZoomComponent,
])
